export default __webpack_public_path__ + "static/media/coliseum-header-bg.17ba1039.png";